// extracted by mini-css-extract-plugin
export default {"root":"Hero_root__39wTa","subtitle":"Hero_subtitle__3IqPY","title":"Hero_title__3gZsf"};